import React, { memo, useState } from 'react';
import { Header } from 'shared/components/Header';
import { Footer } from 'shared/components/Footer';
import { usePriceData } from 'shared/hooks/usePriceData';
import { MainBanner } from './Components/MainBanner';
import styles from './index.module.scss';
import { GameNowBlock } from './Components/GameNowBlock';
import { Goals } from './Components/Goals';
import { InGameBlock } from './Components/InGameBlock';
import { Feedback } from './Components/Feedback';
import { FooterBlock } from './Components/FooterBlock';
import { LINK_PLAY, META, PRODUCT_NAME } from './constants';
import { useEffectOnMount } from '../../../shared/hooks/useEffectOnMount';

export const Science = memo(function Science() {
  const { paymentPath } = usePriceData(PRODUCT_NAME, 990);

  useEffectOnMount(() => {
    document.title = META.title;
  });

  return (
    <div className={styles.contentWrapper}>
      <Header type="gray" />
      <div>
        <MainBanner link={paymentPath} />
        <GameNowBlock link={LINK_PLAY} />
        <Goals />
        <InGameBlock />
        <Feedback />
        <FooterBlock link={paymentPath} />
      </div>
      <Footer />
    </div>
  );
});
